<script setup lang="ts">
import {ref} from "vue";
import {DosageInstruction} from "@/dosage/interfaces/Dosage";
import DosageOptionChip from "@/dosage/components/DosageOptionChip.vue";
import useDosageInstructions from "@/dosage/composables/useDosageInstructions";
import {Plus} from "@lucide/vue";
import {Button} from "@/core/components/ui/button";

const model = defineModel<DosageInstruction | null>({required: true});

const {data} = useDosageInstructions();

const show = ref(false);
</script>

<template>
  <div>
    <Button
      v-if="!show && !model"
      variant="ghost"
      size="xs"
      class="text-xs leading-none text-gray-400 hover:text-primary transition-colors flex items-center gap-1"
      @click="show = true"
    >
      <Plus class="size-3" />
      Ajouter une modalité de prise
    </Button>
    <template v-else>
      <p class="text-xs font-medium text-gray-500 mb-2">
        Modalité
      </p>
      <div class="flex gap-1.5 flex-wrap">
        <DosageOptionChip :selected="model === null" @click="model = null">
          Aucune
        </DosageOptionChip>
        <DosageOptionChip
          v-for="instruction in (data ?? [])"
          :key="instruction.id"
          :selected="model?.id === instruction.id"
          @click="model = instruction"
        >
          {{ instruction.name }}
        </DosageOptionChip>
      </div>
    </template>
  </div>
</template>
